import React from "react"
import { css } from "emotion"
import Text from "./Text"

const Error = ({ error }) => {
  if (!error) {
    return null
  }

  let message = error.message || error
  if (typeof message !== "string") {
    message = "An unexpected error occurred."
  }

  return (
    <Text
      className={css`
        color: red;
      `}>
      {message}
    </Text>
  )
}

export default Error



// WEBPACK FOOTER //
// ./src/components/Error.js